import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "p-d-flex p-justify-end" }

import { computed, ref, watch } from "vue";
import CategoryMultiSelect from "@/components/category/CategoryMultiSelect.vue";
import {
  STOCK_QUANTITY_FILTERS,
  StockRowQuantity,
  useUpdateQuantities,
} from "@/graphql/stock/update.quantities";
import { activeActivity } from "@/plugins/i18n";
import NumberFormatter from "@/components/common/NumberFormatter.vue";
import { useConfirm } from "primevue/useconfirm";
import { useI18n } from "vue-i18n";
import { Category, Product } from "@/graphql/types";
import { useStockPermissions } from "@/hooks/permissions/useStockPermission";


export default /*#__PURE__*/_defineComponent({
  __name: 'StockIn',
  props: {
    products: {},
    categories: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const confirm = useConfirm();
const filters = ref({ ...STOCK_QUANTITY_FILTERS });
const stocks = ref<StockRowQuantity[]>([]);
const currency = activeActivity.value.currencySymbol;
const { canUpdate } = useStockPermissions();
const operationType = computed(() => {
  return props.type === 3
    ? {
        columnHeader: t("stock.entry"),
        style: "max-width: 85px; color: green; font-weight: bold",
      }
    : {
        columnHeader: t("stock.out"),
        style: "max-width: 85px; color: red; font-weight: bold",
      };
});

const { updateQuantities3, updateQuantities4, qLoading } = useUpdateQuantities(
  () => ({})
);

function tabIndexSkipper() {
  setTimeout(() => {
    document.querySelectorAll(".p-button").forEach((button: any) => {
      button.tabIndex = -1;
    });
  }, 100);
}

watch(
  () => props.products,
  (prod) => {
    stocks.value = prod.reduce((acc, prod) => {
      if (prod.type === 0) {
        const { stocks, ...product } = prod;
        return acc.concat(
          stocks.map((st) => Object.assign({ ...st }, { product, nq: null }))
        );
      }
      return acc;
    }, []);
    tabIndexSkipper();
  },
  { immediate: true }
);

function validateAdd() {
  if (props.type === 3) {
    confirm.require({
      group: "dialog",
      header: t("stock.inTitle"),
      message: t("stock.inDetails"),
      icon: "pi pi-exclamation-triangle",
      rejectLabel: t("cancel"),
      acceptLabel: t("confirm"),
      accept: () => updateQuantities3(stocks.value),
    });
  } else {
    confirm.require({
      group: "dialog",
      header: t("stock.outTitle"),
      message: t("stock.outDetails"),
      icon: "pi pi-exclamation-triangle",
      rejectLabel: t("cancel"),
      acceptLabel: t("confirm"),
      accept: () => updateQuantities4(stocks.value),
    });
  }
}

function clearFilter() {
  Object.assign(filters.value, STOCK_QUANTITY_FILTERS);
  filters.value.global.value = "";
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-sm",
    "data-key": "id",
    value: stocks.value,
    responsiveLayout: "scroll",
    loading: _ctx.loading,
    filters: filters.value,
    "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((filters).value = $event)),
    filterDisplay: "menu",
    "show-gridlines": "",
    globalFilterFields: [
      'product.reference',
      'product.name',
      'product.category.label',
    ]
  }, _createSlots({
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-filter-slash",
            label: _ctx.$t('clear'),
            class: "p-button-outlined p-mb-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter()))
          }, null, 8, ["label"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputText, {
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: _ctx.$t('search'),
              "icon-pos": "right"
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        header: _ctx.$t('product.reference'),
        filterField: "product.reference",
        field: "product.reference",
        sortable: true,
        "sort-field": "product.reference"
      }, {
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeyup: _withKeys(filterCallback, ["enter"]),
            class: "p-column-filter",
            placeholder: _ctx.$t('product.filterByRef')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-mr-1",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            onClick: filterCallback,
            type: "button",
            icon: "pi pi-search",
            class: "p-button-success",
            label: _ctx.$t('search')
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        header: _ctx.$t('stock.product'),
        filterField: "product.name",
        field: "product.id",
        sortable: true,
        "sort-field": "product.name"
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.product.name), 1)
        ]),
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            onKeyup: _withKeys(filterCallback, ["enter"]),
            placeholder: _ctx.$t('product.filterByName')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-mr-1",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            onClick: filterCallback,
            type: "button",
            icon: "pi pi-search",
            class: "p-button-success",
            label: _ctx.$t('search')
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        showFilterMatchModes: false,
        "show-add-button": false,
        showFilterOperator: false,
        field: "product.category.id",
        sortable: true,
        "filter-field": "product.category.id",
        header: _ctx.$t('product.category'),
        "show-apply-button": false
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.product.category.label), 1)
        ]),
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(CategoryMultiSelect, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": [($event: any) => ((filterModel.value) = $event), ($event: any) => (filterCallback())],
            items: _ctx.categories,
            style: {"max-width":"220px"}
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            label: _ctx.$t('clear'),
            style: {"width":"100%"}
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "sort-field": "quantity",
        sortable: true,
        field: "quantity",
        header: _ctx.$t('stock.actual'),
        "show-add-button": false,
        showFilterOperator: false,
        "filter-field": "quantity",
        dataType: "numeric"
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(NumberFormatter, {
            value: data.quantity
          }, null, 8, ["value"])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputNumber, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            "max-fraction-digits": 20,
            min: 0,
            mode: "decimal"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-button-sm",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('search'),
            type: "button",
            icon: "pi pi-search",
            class: "p-button-sm",
            onClick: ($event: any) => (filterCallback())
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        header: _ctx.$t('stock.detail')
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(_ctx.$t("stock.purchasePrice")) + " : ", 1),
          _createVNode(NumberFormatter, {
            value: data.purchasePrice
          }, null, 8, ["value"]),
          _createTextVNode(" " + _toDisplayString(_unref(currency)) + " ", 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("stock.sellingPrice")) + " : ", 1),
          _createVNode(NumberFormatter, {
            value: data.inclTax
          }, null, 8, ["value"]),
          _createTextVNode(" " + _toDisplayString(_unref(currency)) + " ", 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(data.expiredAt && _ctx.$t("stock.exp") + _ctx.$d(data.expiredAt)), 1)
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        style: {"max-width":"60px"},
        header: operationType.value.columnHeader
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_InputNumber, {
            style: {"height":"30px"},
            disabled: !_unref(canUpdate),
            mode: "decimal",
            "input-style": operationType.value.style,
            min: 0,
            "allow-empty": "",
            "max-fraction-digits": 20,
            modelValue: data.nq,
            "onUpdate:modelValue": ($event: any) => ((data.nq) = $event),
            modelModifiers: { number: true }
          }, null, 8, ["disabled", "input-style", "modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 2
  }, [
    (_unref(canUpdate))
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                onClick: validateAdd,
                loading: _unref(qLoading),
                disabled: _unref(qLoading),
                label: _ctx.$t('validate'),
                icon: "pi pi-send"
              }, null, 8, ["loading", "disabled", "label"])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["value", "loading", "filters"]))
}
}

})